module.exports = __webpack_public_path__ + "static/media/120.5a10cc82.png";